import { Box, Button, IconButton, Typography } from '@mui/material'
import { styled } from '@mui/system'
import React, { useContext, useState } from 'react'
import { ProductContext } from '../../Context/ProductProvider'
import OfferCard from './OfferCard'
import DisplaySettingsOutlinedIcon from '@mui/icons-material/DisplaySettingsOutlined';
import './sidebar.css'
import CloseIcon from '@mui/icons-material/Close';
import Footer from '../Footer'


// =========================================================================================
// =========================================================================================
const opened =  {
  height: '100vh', width: '25rem', position: 'fixed', 
  zIndex: '1', background: 'black', top: '3rem',
  display: 'block',
}
const closed =  {
  height: '100vh', width: '0rem', position: 'fixed', 
  zIndex: '1', top: '3rem',
  display: 'none'
}
const InputBox =styled(Box)({
  height: '3rem', width: 'auto', background: 'red', position: 'relative', 
  display: 'flex',justifyContent: 'space-between', 
})

const OfferZoneSection = styled(Box)({
  paddingTop: '3rem',maxWidth: '85vw',margin: 'auto'
})
// const Products = styled(Box)({
//   height: 'auto', paddingBottom: '3rem', display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)'
// })
const FilterIcon =styled(IconButton)({
  position: 'relative', left: '-46%', color: 'red', height: '2rem'
})
const FilterBox = styled(Box)({
  minWidth: '27vw',margin: 'auto',position: 'relative',top: '8rem',
})
// =========================================================================================
// =========================================================================================








// =========================================================================================
// =========================================================================================
const OfferZone = () => {

  const {state:{product}} = useContext(ProductContext);
  const [activeFilter , setActiveFilter ]= useState(false)
  const [fromNumber, setFromNumber] =useState();
  const [ toNumber, setToNumber] = useState()

  const offProd = product.slice(1, 15);
  const cal = (offPercent, price)=>{
    let getPercent = Math.floor(price* (offPercent/100));
    let finalPrice = price - getPercent ;
    return finalPrice;
  }
 
  const finalPrice = offProd.map((e)=>{
    return {...e, price: cal(e.offPrice, e.price), off: e.offPrice }
  })
  const [finalProd, setFinalProd] = useState(finalPrice)

  const applyFilter = (from , to)=>{
    let filteredItem = finalPrice.filter((e)=>{
      return e.price >= from && e.price <= to;
    })
    setFinalProd(filteredItem)
  }


  
// =========================================================================================
// =========================================================================================

  return (
    <Box style={{background: 'black'}} >
        <Box>
          <img  src='https://cdn.shopify.com/s/files/1/0057/8938/4802/files/offer-page_strip_Web.jpg?v=1634206843' 
                style={{maxWidth: '100vw', paddingTop: '6rem'}}
                alt='offer' />
        </Box>
        <h1 style={{color: 'white'}}>Offer Zone</h1>


        {/* =========================== FILTER BOX ==================================== */}
        <Box style={activeFilter === true ? opened : closed} >
            <InputBox sx={{top:{xs: '5rem', sm: '5rem', md: '1rem', lg: '1rem'}}} >
              <Typography variant='h5' pl={2} pt={0.5}>Filters</Typography>
              <IconButton style={{paddingRight: '1rem', color: 'white', position: 'inherit'}} onClick={()=>setActiveFilter(false)} >
                <CloseIcon  style={{fontWeight: 'bold', fontSize: '2rem'}} />
              </IconButton>
            </InputBox>
            {/* --------------------------------------------------------------------------- */}
            <FilterBox >
            <h5 style={{textAlign: 'left',color: 'white', paddingLeft:"1.5rem"}}>By Price</h5>
              <Box style={{display: 'flex', justifyContent: 'space-between', paddingRight: '2rem'}} >
                <h4 style={{paddingLeft: '1.5rem', color: 'white'}}>From:</h4>
                <form style={{ paddingTop: '1rem', paddingRight: '1.5rem', height: '1.5rem'}} >
                    <input 
                      type="number" 
                      name="name" 
                      style={{height: '1.5rem', maxWidth: '8rem', borderRadius: '0.25rem', border: '1px solid gray', paddingLeft: '1rem'}}
                      value={fromNumber}
                      required
                      onChange={(e)=>setFromNumber(e.target.value)}
                      />
                </form>
              </Box>
              <Box style={{ display: 'flex', justifyContent: 'space-between', paddingRight: '2rem', paddingTop: '2rem'}} >
                <h4 style={{paddingLeft: '1.5rem', color: 'white'}}>To:</h4>
                <form style={{
                       paddingTop: '1rem', paddingRight: '1.5rem'}} >
                    <input 
                    type="number" 
                    name="name" 
                    style={{height: '1.5rem',maxWidth: '8rem', borderRadius: '0.25rem', border: '1px solid gray'}}
                    value={toNumber}
                    required
                    onChange={(e)=>setToNumber(e.target.value)}
                    />
                </form>
              </Box>
              <Box style={{display: 'grid', gap: '1rem', position: 'relative', maxWidth: '20rem', margin: 'auto',top: '28vh'}}>
                <Button style={{background: 'red', color: 'white', fontWeight: 'bold', position: 'relative'}}
                    onClick={()=> {applyFilter(fromNumber, toNumber); setActiveFilter(false);} }
                    >APPLY FILTERS</Button>
                <Button style={{border: '2px solid red', color: 'white', fontWeight: 'bold', position: 'relative' }}
                    onClick={()=>{setFinalProd(finalPrice); setActiveFilter(false);}}
                    >clear filter</Button>
              </Box>
            </FilterBox>
            {/* --------------------------------------------------------------------------- */}
        </Box>
        {/* =========================== FILTER BOX ==================================== */}



        <OfferZoneSection >
          <FilterIcon onClick={()=>setActiveFilter(true)}>
              <DisplaySettingsOutlinedIcon />
              <h6 style={{paddingLeft: '0.5rem'}}>Filter</h6>
          </FilterIcon>
          <Box sx={{  height: 'auto',
                      paddingBottom: '3rem',
                      display: 'grid',
                      gridTemplateColumns:{ xs: '1fr 1fr', 
                                            sm: '1fr 1fr', 
                                            md: 'repeat(3, 1fr)',
                                            lg: 'repeat(4, 1fr)' } }}>
            {
              finalProd.map((elm, i)=>{
                return (
                  // <Link to='individualItem'>
                    <OfferCard name={elm.name} image={elm.img} price={elm.price} id={elm} key={elm.id} off={elm.offPrice} />
                  // </Link>
                )
              })
            }
          </Box>
        </OfferZoneSection>
        <Footer />
    </Box>
  )
}

export default OfferZone